<template>
  <div class="union" :style="`height: ${height}`">
    <v-ribbon v-if="ribbonText" position="right">{{ ribbonText }}</v-ribbon>
    <div class="union__content-wrapper">
      <v-text class="union__content-wrapper__title mb-3 mr-md-0 mr-6 mt-md-0 mt-3" bold font-size="6">{{ title }}</v-text>
      <v-text class="union__content-wrapper__description mb-2">{{ description }}</v-text>
      <div class="union__content-wrapper__input-wrapper">
        <div v-if="ctaText && !current" class="union__content-wrapper__ctaText bg-primary text-light p-2">
          <v-text>{{ ctaText }}</v-text>
          <div class="bg-primary union__content-wrapper__ctaText__arrow"></div>
        </div>
        <slot name="content" :show="show"></slot>
      </div>
    </div>
    <div v-if="current === 'inputModal'" class="union__modal">
      <slot name="inputModal" :setSubmit="setSubmit"></slot>
    </div>
    <div v-if="current === 'confirmModal'" class="union__modal">
      <slot name="confirmModal" :setSubmit="setSubmit"></slot>
    </div>
    <div v-if="current && current != '0'" class="union__outside-clicker" @click="clearSelected()"></div>
    <div class="union__img-wrapper">
      <img class="union__img-wrapper__img" :src="imgSrc" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: null,
      submitted: false
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: null
    },
    imgSrc: {
      type: String,
      default: null
    },
    ribbonText: {
      type: String,
      default: null
    },
    ctaText: {
      type: String,
      default: null
    },
    height: {
      type: [Number, String],
      default: "400px"
    }
  },
  methods: {
    show(type) {
      if (type === this.current) {
        this.current = "0";
      }
      this.current = type;
    },
    clearSelected() {
      if (!this.submitted) {
        this.current = "0";
        this.chosenOption = null;
        this.$emit("clear");
      }
    },
    setSubmit() {
      this.submitted = true;
    }
  }
};
</script>
<style lang="scss">
@import "../../sass/component.scss";

.union {
  background-color: theme-color("gray");
  border-radius: 8px;
  position: relative;

  &__content-wrapper {
    position: relative;
    padding: 5% 15% 0;
    z-index: 4;

    @include media-breakpoint-down(md) {
      padding: 5%;
    }

    @include media-breakpoint-down(sm) {
      padding: 5% 2%;
    }

    &__title,
    &__description {
      text-align: center;
    }

    &__input-wrapper {
      margin: 60px auto 0;
      width: 400px;
      position: relative;

      @include media-breakpoint-down(sm) {
        width: 300px;
      }
    }

    &__ctaText {
      width: 90px;
      border-radius: 5px;
      position: absolute;
      left: 0;
      text-align: center;
      top: -50px;

      &__arrow {
        width: 20px;
        height: 10px;
        transform: rotate(45deg);
        position: absolute;
        right: 45%;
      }
    }
  }

  &__img-wrapper {
    overflow: hidden;
    height: 175px;
    bottom: 0;
    position: absolute;
    width: 100%;
    border-radius: 5px;

    &__img {
      max-width: none !important;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -98px);
      top: 100px;
      z-index: 1;
    }
  }

  &__modal {
    position: absolute;
    border-radius: 5px;
    margin-top: -9px;
    box-shadow: 6px 6px 7px #00000026;
    background-color: theme-color("white");
    padding: 20px 25px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    width: 400px;

    @include media-breakpoint-down(md) {
      margin-top: -30px;
    }

    @include media-breakpoint-down(sm) {
      padding: 20px;
      min-width: 300px;
      width: 300px;
      margin-top: -30px;
    }
  }

  &__outside-clicker {
    position: absolute;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 9;
  }
}
</style>
